import { render, staticRenderFns } from "./PropertiesMapView.vue?vue&type=template&id=537ac57a"
import script from "./PropertiesMapView.vue?vue&type=script&lang=js"
export * from "./PropertiesMapView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports